module.exports = __webpack_public_path__ + "static/media/life-leader-board-banner-mobile.c5043253.jpg";